var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('el-form-item',{attrs:{"label":_vm.$t('lang.热风') + '：'}},[_c('el-switch',{attrs:{"inactive-value":"0","active-value":"1","disabled":_vm.disabled},on:{"change":_vm.handleChange},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }